import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { setOnSale, setWithSubscription } from 'Pods/SearchPage/Store/actions/pricing'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

import { getPricingCheckboxFiltersConfig, isTierFilterAvailable } from './constants'
import PriceInputs from './PriceInputs/PriceInputs'
import RangeButtons from './RangeButtons/RangeButtons'
import SubscriptionPromo from './SubscriptionPromo/SubscriptionPromo'
import SubscriptionTier from './SubscriptionTier/SubscriptionTier'

function PriceContent() {
  const translate = useTranslate()
  const pageConfig = usePageConfig()

  // Without the tier filter it falls back to the plain on/off checkbox. Safe to read pageConfig
  // directly: this content only mounts after the user opens the dropdown or the drawer, never
  // during SSR.
  const hasTierFilter = isTierFilterAvailable(pageConfig)
  const showSubscriptionPromo = hasTierFilter && !pageConfig?.isActiveSubscriber

  const onSale = useSearchPageStore(state => state.onSale)
  const withSubscription = useSearchPageStore(state => state.withSubscription)
  const trackFilterSelect = useTrackFilterSelect()

  const handleCheckboxFilterChange = useCallback((_, value, isOn) => {
    if (isOn) {
      trackFilterSelect(FILTER_NAME.PRICE, value)
    }
    if (value === 'on_sale') {
      setOnSale(isOn)
    } else if (value === 'with_subscription') {
      setWithSubscription(isOn)
    }
  }, [trackFilterSelect])

  const selectedCheckboxFilters = useMemo(() => {
    const selected = []
    if (onSale) selected.push('on_sale')
    if (withSubscription) selected.push('with_subscription')
    return selected
  }, [onSale, withSubscription])

  const checkboxFiltersConfig = useMemo(
    () => getPricingCheckboxFiltersConfig(translate, !hasTierFilter),
    [translate, hasTierFilter]
  )

  return (
    <>
      <FiltersSidebar
        isCollapsible={false}
        filters={checkboxFiltersConfig}
        selectedFilters={selectedCheckboxFilters}
        onFiltersChange={handleCheckboxFilterChange}
        isControlled
        useNewCheckboxes
        hideLastDivider
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
      />
      <RangeButtons />
      <PriceInputs />
      {hasTierFilter && <SubscriptionTier />}
      {showSubscriptionPromo && (
        <SubscriptionPromo monthlyModels={pageConfig.threeDStudioSubscriptionMonthlyModels} />
      )}
    </>
  )
}

PriceContent.propTypes = {}

export default memo(PriceContent)
